import { API } from 'aws-amplify'

export default async (userId, deviceId, params) => {
  return API.put('uiconfig', `user/${userId}/device/${deviceId}`, { body: params })
}
